// @require ./cash.js

export const isFunction = x => typeof x === 'function';

export const isString = x => typeof x === 'string';

export const isNumeric = x => !isNaN(parseFloat(x)) && isFinite(x);

export const isArray = Array.isArray;
